module.exports = __webpack_public_path__ + "img/2.b7ea2082.png";